var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocket = function SvgSocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.779-6.306 14.085-14.083 14.085C6.6 33.453.295 27.143.295 19.365.295 11.587 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.38 23.503c2.6 0 4.708-2.108 4.708-4.709v-2.442h-2.355m-2.353 7.15a4.708 4.708 0 0 1-4.708-4.708v-2.442h7.061m-2.353 7.15c0 1.457 0 3.07 2.353 3.07h1.046m-1.046-10.22v-2.925m-4.711 2.925v-2.925",
    stroke: "#0086C9",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgSocket;